var GRFQConfigs = {
    app_url : "https://app.shopifydevelopers.net/requestforquotev2",
    theme_store_id : 796,
    shop_url : "womido.myshopify.com",
    domain : "",
    front_shop_url : "www.womido.de",
    collection_enable : 0 ,
    product_enable : 1 ,
    rfq_page :  "request-for-quote" ,
    rfq_history :  "quotes-history" ,
    lang_translations: [],
    translation_default: {
        button: "Add to Quote",
        popupsuccess: "The product %s is added to your quote.",
        popupcontinue: "Continue Shopping",
        popupviewquote: "View Quote",
        toast_message: "Product added to quote",
        pageempty: "Your quote is currently empty.",
        pagebutton: "Submit Request",
        pagesuccess: "Thank you for submitting a request a quote!",
        pagecontinueshopping: "Continue Shopping",
        pageimage: "",
        pageproduct: "Product",
        pagevendor: "Vendor",
        pagesku: "SKU",
        pageoption: "Option",
        pagequantity: "Quantity",
        pageprice: "Price",
        pageremove: "Remove",
        error_messages: {"required":"Please fill in this field","invalid_email":"Invalid email","file_size_limit":"File size exceed limit","file_not_allowed":"File extension is not allowed","required_captcha":"Please verify captcha"},
        historylogin: "You have to {login|login} to use Quote history feature.",
        historyempty: "You haven&#039;t placed any quote yet.",
        historyaccount: "Account Information",
        historycustomer: "Customer Name",
        historyid: "",
        historydate: "Date",
        historyitems: "Items",
        historyaction: "Action",
        historyview: "View",
        message_toast:  "Product added to quote" ,
    },
    show_buynow:  2 ,
    show_atc:  2 ,
    show_price:  2 ,
    convert_cart_enable:  2 ,
    redirectUrl:  '' ,
    message_type_afteratq:  "popup" ,
    selector: {
        buynow_selector: '.shopify-payment-button',
        addtocart_selector: '.product__submit__add,form #AddToCart-product-template, form #AddToCart, form #addToCart-product-template, form .product__add-to-cart-button, form .product-form__cart-submit, form .add-to-cart, form .cart-functions > button, form .productitem--action-atc, form .product-form--atc-button, form .product-menu-button-atc, form .product__add-to-cart, form .product-add, form .add-to-cart-button, form #addToCart, form .product-detail__form__action > button, form .product-form-submit-wrap > input, form .product-form input[type="submit"], form input.submit, form .add_to_cart, form .product-item-quick-shop, form #add-to-cart, form .productForm-submit, form .add-to-cart-btn, form .product-single__add-btn, form .quick-add--add-button, form .product-page--add-to-cart, form .addToCart, form .product-form .form-actions, form .button.add, form button#add, form .addtocart, form .AddtoCart, form .product-add input.add, form button#purchase, form[action*="/cart/add"] button[type="submit"], form .product__form button[type="submit"], form #AddToCart--product-template',
        price_selector: '#ProductPrice-product-template,#ProductPrice,.product-price,.product__price—reg,#productPrice-product-template,.product__current-price,.product-thumb-caption-price-current,.product-item-caption-price-current,.grid-product__price,.product__price,span.price,span.product-price,.productitem--price,.product-pricing,span.money,.product-item__price,.product-list-item-price,p.price,div.price,.product-meta__prices,div.product-price,span#price,.price.money,h3.price,a.price,.price-area,.product-item-price,.pricearea,.collectionGrid .collectionBlock-info > p,#ComparePrice,.product--price-wrapper,.product-page--price-wrapper,.color--shop-accent.font-size--s.t--meta.f--main,.ComparePrice,.ProductPrice,.prodThumb .title span:last-child,.price,.product-single__price-product-template,.product-info-price,.price-money,.prod-price,#price-field,.product-grid--price,.prices,.pricing,#product-price,.money-styling,.compare-at-price,.product-item--price,.card__price,.product-card__price,.product-price__price,.product-item__price-wrapper,.product-single__price,.grid-product__price-wrap,a.grid-link p.grid-link__meta',
    },
    money_format: "€",
        rules: {"all":{"enable":true},"manual":{"enable":false,"manual_products":"7450414612713"},"automate":{"enable":true,"automate_rule":[{"value":"dein produkt","where":"CONTAINS","select":"TITLE"}],"automate_operator":"and"}},
        settings: {
        historylogin:  "You have to {login|login} to use Quote history feature."     },
}